import { EMPTY_ARRAY } from 'utils/emptyConstants'

const selectDestinationsState = (state) => state.settings?.alerts?.destinations

export const isV2Destination = (destination) => destination?.dataModelVersion === 'V2'

export const selectDestinations = (state) =>
  selectDestinationsState(state)?.destinations ?? EMPTY_ARRAY

export const selectLegacyDestinations = (state) =>
  selectDestinations(state).filter((destination) => !isV2Destination(destination))
export const selectCatalogLoader = (state) => selectDestinationsState(state)?.catalogLoader ?? false
export const selectCatalogError = (state) => selectDestinationsState(state)?.catalogError ?? null

export const selectDrawerOpen = (state) => selectDestinationsState(state)?.drawerOpen ?? false
export const selectDrawerMode = (state) => selectDestinationsState(state)?.drawerMode ?? null
export const selectDrawerDestinationId = (state) =>
  selectDestinationsState(state)?.drawerDestinationId ?? null
export const selectDrawerData = (state) => selectDestinationsState(state)?.drawerData ?? null
export const selectDrawerLoader = (state) => selectDestinationsState(state)?.drawerLoader ?? false
export const selectDrawerError = (state) => selectDestinationsState(state)?.drawerError ?? null
export const selectDrawerSaving = (state) => selectDestinationsState(state)?.drawerSaving ?? false

export const selectRemoveConfirmOpen = (state) =>
  selectDestinationsState(state)?.removeConfirmOpen ?? false
export const selectRemoveDestinationId = (state) =>
  selectDestinationsState(state)?.removeDestinationId ?? null
export const selectRemoveLoading = (state) => selectDestinationsState(state)?.removeLoading ?? false
export const selectRemoveError = (state) => selectDestinationsState(state)?.removeError ?? null
